<template>
    <div class="o-hints" v-if="snippet && snippet.snippetContentResponseList">
        <fieldset class="o-hints__fieldset">
            <legend class="o-hints__legend d-flex align-items-center gap-0-5">
                <a-icon
                    style="color: var(--color-orange)"
                    width="20px"
                    height="20px"
                    icon="Bulb"
                    :style="'margin-top: -4px'"
                />Czy wiesz, że...
            </legend>
            <ui-slider
                :options="sliderOptions"
                :content="snippetContent"
                @transitionStart="onTransitionStart($event)"
                @onInit="onTransitionStart($event)"
            ></ui-slider>
        </fieldset>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sliderOptions: {
                mouseDrag: false,
                items: 1,
                nav: false,
                autoplay: true,
                loop: true,
                'autoplay-timeout': 8000,
                'autoplay-button': false,
                'autoplay-button-output': false,
                preventScrollOnTouch: 'auto',
                controls: false,
                speed: 1000,
                autoHeight: true
            },
            snippetContent: ''
        }
    },
    props: {
        snippetCode: {
            type: String,
            required: true
        }
    },
    methods: {
        fetch() {
            return this.$store.dispatch('snippetsFetch', {
                code: this.snippetCode
            })
        },
        setSnippetContent(snippet) {
            const snip = this.snippet || snippet
            if (snip && snip.snippetContentResponseList) {
                const contents = JSON.parse(
                    JSON.stringify(snip.snippetContentResponseList)
                ).sort(() => 0.5 - Math.random())
                contents.forEach(el => {
                    this.snippetContent += `<div>${el.content}</div>`
                })
            }
        },
        onTransitionStart(slider) {
            this.adjustModalHeight(false, slider)
        },
        adjustModalHeight(initialAdjust, slider) {
            this.$nextTick(() => {
                const modal = document.querySelector('.modal-content')
                const loader = document.querySelector(
                    '.loading-wrapper-mode .loader'
                )
                const content = document.querySelector(
                    '.loading-wrapper-mode .content'
                )

                if (loader && content && modal) {
                    const slideCurrent =
                        slider?.slideItems[slider.displayIndex].offsetHeight ||
                        0
                    const slidePrev =
                        slider?.slideItems[slider.indexCached].offsetHeight || 0

                    const prevContentH = content.offsetHeight
                    modal.style.height = 'auto'
                    content.style.height = 'auto'
                    if (!initialAdjust) {
                        loader.style.height = 'auto'
                    } else {
                        loader.style.height = `${modal.offsetHeight + 10}px`
                    }
                    setTimeout(() => {
                        const header = document.querySelector('.modal-header')
                        const modalH = modal.offsetHeight
                        const headerH = header.offsetHeight
                        const loaderH = loader.offsetHeight
                        const contentH = modalH - headerH
                        content.style.height = `${prevContentH}px`

                        setTimeout(() => {
                            if (loaderH < contentH) {
                                content.style.height = `${contentH}px`
                            } else {
                                loader.style.height = 'auto'
                                content.style.height = `${loaderH -
                                    slidePrev +
                                    slideCurrent +
                                    16}px`
                            }
                        }, 0)
                    }, 0)
                }
            })
        }
    },
    computed: {
        snippet() {
            return this.$store.getters.getSnippet(this.snippetCode)
        }
    },
    beforeDestroy() {
        const content = document.querySelector('.loading-wrapper-mode .content')
        if (content) {
            content.style.height = 'auto'
        }
        const loader = document.querySelector('.loading-wrapper-mode .loader')
        if (loader) {
            loader.style.height = '100%'
        }
    },
    async created() {
        const snippet = await this.fetch()
        this.setSnippetContent(snippet)
        this.$nextTick(() => {
            this.adjustModalHeight(true)
        })
    }
}
</script>
